module.exports = __webpack_public_path__ + "media/schrank_geoeffnet.b00d4107.mp3";